import { render } from "./promptDialog.vue?vue&type=template&id=05f287c0"
import script from "./promptDialog.vue?vue&type=script&lang=js"
export * from "./promptDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__